"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

var _UIIcon = _interopRequireDefault(require("UIComponents/icon/UIIcon"));

var _UsersClient = require("../data/UsersClient");

var _auth = require("../selectors/auth");

var USER_ATTRIBUTE_KEY = 'MarketplaceUI:hideTopNavAlert';

var getI18nKey = function getI18nKey(key) {
  return "MarketplaceUI.navAlert." + key;
};

var MarketplaceNavAlert = function MarketplaceNavAlert(_ref) {
  var userId = _ref.userId;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      show = _useState2[0],
      setShow = _useState2[1];

  var handleClose = function handleClose() {
    (0, _UsersClient.createAttribute)(userId, USER_ATTRIBUTE_KEY, true);
    setShow(false);
  };

  (0, _react.useEffect)(function () {
    (0, _UsersClient.fetchAttributes)(userId).then(function (_ref2) {
      var attributes = _ref2.attributes;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = attributes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var _ref4 = _step.value;
          var key = _ref4.key;

          if (key === USER_ATTRIBUTE_KEY) {
            return;
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return != null) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      setShow(true);
    }).catch(function (error) {
      console.error('error fetching user attributes\n', error.stack || error);
      setShow(true);
    });
  }, [userId]);

  if (!show) {
    return null;
  }

  return _react.default.createElement(_UIAlert.default, {
    className: "m-top-4",
    closeable: true,
    onClose: handleClose,
    titleText: (0, _unescapedText.default)(getI18nKey('titleText')),
    type: "info"
  }, _react.default.createElement(_FormattedJSXMessage.default, {
    message: getI18nKey('message_jsx'),
    elements: {
      Icon: _UIIcon.default
    },
    options: {
      name: 'marketplace',
      size: 20
    }
  }));
};

MarketplaceNavAlert.propTypes = {
  userId: _propTypes.default.number.isRequired
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    userId: (0, _auth.getCurrentUserId)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(MarketplaceNavAlert);

exports.default = _default;
module.exports = exports.default;